import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { ProjectList } from '../strategy/ProjectList';
import { useAuthContext } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function ProjectListWrapper() {
    const { key } = useLocation();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return (
        <>
            <DocumentTitle title="Projects"></DocumentTitle>
            <ProjectList user={user} refreshIdentifier={key} zoneContext={zoneContext} />
        </>
    );
}

export default ProjectListWrapper;
